import React from 'react';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import PermissionSummary from './PermissionSummary';

/**
 * Componente de tarjeta para mostrar un usuario y sus permisos
 */
const UserCard = ({ 
  usuario, 
  modulos, 
  permisos, 
  onEditPermissions, 
  canEditUsers 
}) => {
  
  // Función para obtener el resumen de permisos del usuario
  const getPermissionsSummary = () => {
    // Adaptarse a la nueva estructura: usuario.modulos en lugar de usuario.permisos
    if (!usuario.modulos || !modulos) {
      return { total: 0, withPermissions: 0 };
    }
    
    const totalModulos = modulos.length;
    // Contar módulos que tienen permisos (permisos.length > 0)
    const modulosWithPermissions = Object.values(usuario.modulos).filter(
      modulo => modulo.permisos && modulo.permisos.length > 0
    ).length;
    
    return {
      total: totalModulos,
      withPermissions: modulosWithPermissions
    };
  };

  const summary = getPermissionsSummary();

  // Si no hay datos, mostrar indicador de carga
  if (!modulos || modulos.length === 0) {
    console.log('⚠️ UserCard - Sin módulos disponibles');
    return (
      <Card className="mb-3" style={{ 
        border: '1px solid #dee2e6',
        borderRadius: '8px',
        overflow: 'hidden'
      }}>
        <Card.Body style={{ padding: '16px', textAlign: 'center', color: '#6c757d' }}>
          <div>Cargando información de módulos...</div>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="mb-3" style={{ 
      border: '1px solid #dee2e6',
      borderRadius: '8px',
      overflow: 'hidden',
      transition: 'box-shadow 0.2s ease',
      ':hover': {
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }
    }}>
      <Card.Body style={{ padding: '16px' }}>
        <Row className="align-items-center">
          {/* Información del Usuario */}
          <Col md={2}>
            <div className="d-flex align-items-center">
              {/* <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                backgroundColor: usuario.activo ? '#28a745' : '#dc3545',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '18px',
                fontWeight: '600',
                marginRight: '12px'
              }}>
                {(usuario.displayName || usuario.nombre || 'U').charAt(0).toUpperCase()}
              </div> */}
              <div>
                <h6 style={{ 
                  margin: '0 0 4px 0', 
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#212529'
                }}>
                  {usuario.displayName || usuario.nombre || 'Sin nombre'}
                </h6>
                <p style={{ 
                  margin: '0 0 4px 0', 
                  fontSize: '12px',
                  color: '#6c757d'
                }}>
                  {usuario.email}
                </p>
                <Badge 
                  bg={usuario.activo ? 'success' : 'danger'}
                  style={{ fontSize: '10px' }}
                >
                  {usuario.activo ? 'Activo' : 'Inactivo'}
                </Badge>
              </div>
            </div>
          </Col>

          {/* Resumen de Permisos */}
          <Col md={3}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '24px', fontWeight: '600', color: '#007bff' }}>
                {summary.withPermissions}/{summary.total}
              </div>
              <div style={{ fontSize: '12px', color: '#6c757d' }}>
                Módulos con permisos
              </div>
            </div>
          </Col>

          {/* Permisos por Módulo */}
          <Col md={7}>
            <PermissionSummary
              usuario={usuario}
              modulos={modulos}
              permisos={permisos}
              onEditPermissions={onEditPermissions}
              canEdit={canEditUsers}
            />
          </Col>

          {/* Acciones - Desactivado temporalmente */}
          {/* 
          <Col md={1}>
            <div style={{ textAlign: 'right' }}>
              {canEditUsers && (
                <button
                  onClick={() => onEditPermissions && onEditPermissions(usuario)}
                  style={{
                    backgroundColor: 'transparent',
                    border: '1px solid #dee2e6',
                    borderRadius: '6px',
                    padding: '8px',
                    cursor: 'pointer',
                    color: '#6c757d',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#f8f9fa';
                    e.target.style.borderColor = '#007bff';
                    e.target.style.color = '#007bff';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.borderColor = '#dee2e6';
                    e.target.style.color = '#6c757d';
                  }}
                  title="Editar permisos"
                >
                  <FaIcons.FaEdit />
                </button>
              )}
            </div>
          </Col>
          */}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default UserCard;
